export const getEnv = (key, defaultValue = undefined) => {
  const value = import.meta.env[key];
  return value === undefined || value === null || value === ''
    ? defaultValue
    : value;
};

export const getAppEnv = (key, defaultValue = undefined) => {
  return getEnv(`VITE_${key}`) ?? defaultValue;
};
